import { useAsyncLoader } from '@aboutyou/legacy-shared/src/utils/hooks/useAsyncLoader'
import { useCallback } from 'react'
import { BRAND_DEFAULT_SET } from 'services/sets/brand'
import { useService } from 'services/utils/context'

export const useLikedBrandLoader = (likedBrandIds: string[]) => {
  const service = useService()
  const likedBrandsIdsCommaSeparated = likedBrandIds.join(',')
  const brands = useAsyncLoader(
    useCallback(
      () =>
        service.brands.requestByIds(likedBrandIds, BRAND_DEFAULT_SET, {
          strategy: 'cache_or_network',
        }),
      [likedBrandsIdsCommaSeparated],
    ),
  )

  if (!brands || brands instanceof Error) {
    return []
  }
  return brands
}
